import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import ShippingDisclaimer from "../components/ShippingDisclaimer";

const FILTERS = [
  { id: "all", label: "All Strains" },
  { id: "green", label: "Green" },
  { id: "super-green", label: "Super Green" },
  { id: "red", label: "Red" },
  { id: "brown", label: "Brown" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const active = params.get("strain") || "all";
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data));
  }, []);

  const filtered = useMemo(
    () => active === "all" ? products : products.filter((p) => p.strain === active),
    [active, products],
  );

  return (
  <>
    <Helmet>
      <title>Shop Premium Borneo Kratom | Kratoven</title>
      <meta
        name="description"
        content="Browse premium Green, Super Green, Red and Brown Borneo kratom. Lab-tested quality with worldwide shipping."
      />
      <link rel="canonical" href="https://kratoven.com/shop" />
    </Helmet>

    <div className="container-kv pt-32 pb-20" data-testid="shop-page">
      <div className="mb-10">
        <div className="overline mb-3">Collection</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light mb-4">
          The Kratoven <em className="italic text-[#C8A97E]">library</em>
        </h1>
        <p className="text-[#A8A5A1] max-w-2xl">
          Four strains, each expressing a different side of Borneo. Select your variant
          and weight at checkout.
        </p>
      </div>

      <div className="mb-8">
        <ShippingDisclaimer compact />
      </div>

      <div className="flex flex-wrap gap-2 mb-10 border-b border-white/5 pb-4" data-testid="shop-filters">
        {FILTERS.map((f) => (
          <button
            key={f.id}
            onClick={() => setParams(f.id === "all" ? {} : { strain: f.id })}
            className={`px-4 py-2 text-sm tracking-wide transition-colors ${
              active === f.id ? "text-[#C8A97E] border-b-2 border-[#C8A97E]" : "text-[#A8A5A1] hover:text-white"
            }`}
            data-testid={`filter-${f.id}`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-20 text-[#75726D]">Loading collection...</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="product-grid">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  </>
);
}